import get from 'lodash/get'

export const initialState = {
  centerMap: null,
}

export const getCenterMap = (state = initialState) => get(state, 'centerMap')
